var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { getFetchWrapper } from "@syf-api-library/core";
import { rewardsCertificateUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId,
      certificateRequestType: keyProps.certificateRequestType
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    if (keyProps.certificateNumber) {
      params.set("certificateNumber", keyProps.certificateNumber);
    }
    return fetchWrapper(`${rewardsCertificateUrl}?${params}`, {
      method: "GET",
      headers: __spreadValues({}, config.clientId && { "Client-Id": config.clientId })
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
